export default "/images/vendor/flag-icon-css/flags/4x3/gq.svg?c2cb1adba91b64af03bc41a5597899eb";